import { render, staticRenderFns } from "./BrushPanel.vue?vue&type=template&id=0c162cfd&"
import script from "./BrushPanel.vue?vue&type=script&lang=js&"
export * from "./BrushPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BrushPanel.vue"
export default component.exports